import { render, staticRenderFns } from "./highFrequency.vue?vue&type=template&id=63006c44&scoped=true"
import script from "./highFrequency.vue?vue&type=script&lang=js"
export * from "./highFrequency.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=63006c44&prod&scoped=true&lang=css&external"
import style1 from "./highFrequency.vue?vue&type=style&index=1&id=63006c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63006c44",
  null
  
)

export default component.exports